import styled from '@emotion/styled';
import themeGet from '@styled-system/theme-get';

export const StyledFooter = styled.footer`
  padding: ${themeGet('scale.scaleUp10')} 0 ${themeGet('scale.scaleUp07')};
  background-color: ${themeGet('color.colorBlueLightest')};

  p {
    font-size: ${themeGet('scale.scaleBase')};
  }
`;

export const StyledFooterGrid = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  > div {
    flex: 1 1 15%;
    margin: 0 ${themeGet('scale.scaleUp03')} ${themeGet('scale.scaleUp03')};
  }

  @supports (display: grid) {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: ${themeGet('scale.scaleUp06')};

    > div {
      flex: 0;
      margin: 0;
    }

    @media (min-width: ${themeGet('breakpoint.breakpointSmall')}) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media (min-width: 863px) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
      grid-template-columns: repeat(4, 1fr);
    }

    @media (min-width: 1072px) {
      grid-template-columns: repeat(5, 1fr);
    }
  }
`;

export const StyledFooterLinks = styled.ul`
  li {
    font-size: ${themeGet('scale.scaleDown01')};
    margin-bottom: ${themeGet('scale.scaleUp02')};
  }

  a {
    color: ${themeGet('color.colorGrayBlue70')};
    text-decoration: none;
  }

  a:hover {
    color: ${themeGet('color.colorBlue')};
  }
`;

export const StyledFooterBottom = styled.div`
  margin-top: ${themeGet('scale.scaleUp08')};
  padding: ${themeGet('scale.scaleUp08')} 0 0;
  border-top: ${themeGet('border.borderSmall')} solid
    ${themeGet('color.colorGrayBlue30')};
`;

export const StyledUl = styled.ul`
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    flex-direction: row;
  }

  li {
    margin-bottom: ${themeGet('scale.scaleUp01')};
    font-size: ${themeGet('scale.scaleDown01')};
    color: ${themeGet('color.colorGrayBlue70')};

    @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
      margin-right: ${themeGet('scale.scaleUp04')};
      margin-bottom: 0;
    }

    &:last-of-type {
      margin-bottom: 0;

      @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
        margin-right: 0;
      }
    }
  }

  a {
    color: ${themeGet('color.colorGrayBlue70')};
    text-decoration: none;

    &:hover {
      color: ${themeGet('color.colorBlue')};
    }
  }
`;

export const StyledSocialUl = styled.ul`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    justify-content: flex-end;
  }

  li {
    margin-left: ${themeGet('scale.scaleDown02')};

    &:first-of-type {
      margin-left: 0;
    }
  }

  svg {
    width: auto;
    height: ${themeGet('scale.scaleBase')};
  }
`;

export const StyledMaintenanceFooter = styled.footer`
  background-color: ${themeGet('color.colorBlueLightest')};
  padding: 0 0 ${themeGet('scale.scaleUp07')};

  ${StyledFooterBottom} {
    margin: 0;
    border: 0;
  }

  p {
    font-size: ${themeGet('scale.scaleBase')};
  }
`;
